'use client';

import React from 'react';
import { Box, Text, HStack, Badge } from '@skin-seoul/design-system';
export type DropdownOptionStatus = 'instock' | 'selected' | 'outofstock';
export interface DropdownOptionProps {
  label: string;
  status: DropdownOptionStatus;
  onClick?: () => void;
  disabled?: boolean;
}
const DropdownOption = ({
  label,
  status,
  onClick,
  disabled = false
}: DropdownOptionProps) => {
  const getBackgroundColor = () => {
    switch (status) {
      case 'selected':
        return 'primary.100';
      case 'outofstock':
        return 'white';
      default:
        return 'white';
    }
  };
  const getTextColor = () => {
    switch (status) {
      case 'outofstock':
        return 'neutral.400';
      default:
        return 'neutral.700';
    }
  };
  const getTextDecoration = () => {
    return status === 'outofstock' ? 'line-through' : 'none';
  };
  return <Box as="button" width="100%" height="44px" backgroundColor={getBackgroundColor()} color={getTextColor()} borderRadius="0" paddingX={4} paddingY={3} borderBottom="1px solid" borderColor="neutral.100" textAlign="left" cursor={disabled ? 'not-allowed' : 'pointer'} opacity={disabled ? 0.5 : 1} _hover={!disabled ? {
    backgroundColor: status === 'selected' ? 'primary.100' : 'neutral.50'
  } : {}} _active={!disabled ? {
    backgroundColor: status === 'selected' ? 'primary.100' : 'neutral.100'
  } : {}} onClick={disabled ? undefined : onClick} display="flex" alignItems="center" justifyContent="space-between" data-sentry-element="Box" data-sentry-component="DropdownOption" data-sentry-source-file="DropdownOption.tsx">
      <Text textStyle="label.large" fontWeight="normal" textDecoration={getTextDecoration()} flex={1} textAlign="left" data-sentry-element="Text" data-sentry-source-file="DropdownOption.tsx">
        {label}
      </Text>

      <HStack gap={2} alignItems="center" data-sentry-element="HStack" data-sentry-source-file="DropdownOption.tsx">
        {status === 'outofstock' && <Badge backgroundColor="warning.50" color="warning.500" textStyle="label.small" fontWeight="normal" paddingX={1} paddingY={0.5} borderRadius="sm" border="1px solid" borderColor="warning.50">
            Out of stock
          </Badge>}

        {status === 'selected' && <Box width="16px" height="16px" display="flex" alignItems="center" justifyContent="center">
            <Text textStyle="label.small" fontWeight="bold" color="currentColor">
              ✓
            </Text>
          </Box>}
      </HStack>
    </Box>;
};
export default DropdownOption;